import React from "react";
import PropTypes from "prop-types";
import { Row } from "gatsby-theme-carbon";

import styles from "./ImageCollection.module.scss";

function ImageCollection(props) {
  const { children } = props;

  const addClass = (child, key) => {
    let newClassName;
    if (child.props.className) {
      newClassName = `${child.props.className} ${styles.image}`;
    } else {
      newClassName = styles.image;
    }

    const props = {
      className: newClassName,
      key,
    };

    return React.cloneElement(child, props);
  };

  return (
    <Row className={styles.container}>
      {Array.isArray(children) &&
        children.map((child, index) => addClass(child, index))}
    </Row>
  );
}

ImageCollection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ImageCollection;
